import { render, staticRenderFns } from "./dialogModule.vue?vue&type=template&id=276263c2&scoped=true&"
import script from "./dialogModule.vue?vue&type=script&lang=js&"
export * from "./dialogModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276263c2",
  null
  
)

export default component.exports